module.exports = __webpack_public_path__ + "img/mobile1.68add103.png";